module.exports = __webpack_public_path__ + "static/media/white-right-arrow-pointer.987c476b.svg";